import { FC, useEffect, useState } from 'react';
import {
  initRoute,
  serviceDomainList,
  changeRoute,
} from '@bfe/by-route-finder';
import { isPC, uniframeReady } from '@spot-fe/utils';
import './index.scss';

interface FooterProps {
  locale?: string;
  uniframeHasReady?: boolean;
}

export const Footer: FC<FooterProps> = ({ locale, uniframeHasReady }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const wrapperEle = document.getElementById('__bybit_uniframe_footer__');
    if (wrapperEle && !isPC()) {
      wrapperEle.style.display = 'none';
      return;
    }

    if(!uniframeHasReady) return;

    uniframeReady().then(() => {
      (window as any)?.BybitUniFrame.ready(({ footer }) => {
        footer.init({ containerId: '__bybit_uniframe_footer__' }).then(() => {
          // const { ROUTE_SELECT } = footer.events;
          // const { SERVICE_DOMAIN_LIST, CURRENT_DOMAIN } = footer.properties;
          footer
            .setProperty('locale', locale);

          setInitialized(true);
        });
      });
    });
  }, [locale, uniframeHasReady]);

  useEffect(() => {
    if (!initialized) return;

    if ((window as any)?.BybitUniFrame?.footer) {
      (window as any)?.BybitUniFrame.footer.setProperty('locale', locale);
    }
  }, [initialized, locale]);

  return null;
};
